import { render, staticRenderFns } from "./HeaderName.vue?vue&type=template&id=0e2d8f72&scoped=true&"
import script from "./HeaderName.vue?vue&type=script&lang=js&"
export * from "./HeaderName.vue?vue&type=script&lang=js&"
import style0 from "./HeaderName.vue?vue&type=style&index=0&id=0e2d8f72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2d8f72",
  null
  
)

export default component.exports